$(function(){
    if(/constructor/i.test(window.HTMLElement)) $("body").addClass("safari-fix");
    if(navigator.userAgent.match(/Windows Phone/i) || navigator.userAgent.match(/WPDesktop/i)) $("body").addClass("winphone-fix");
})